"use strict";
/**
 * Formatter functions for UI display
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCareerField = exports.formatSexualOrientation = exports.formatReligion = exports.formatPoliticalView = exports.formatEthnicity = exports.formatLanguage = exports.formatRelationshipStructure = exports.formatFlexibility = exports.formatIncome = exports.formatEmployment = exports.formatEducation = exports.formatBodyType = exports.formatZodiacSign = exports.formatExercise = exports.formatFrequency = void 0;
exports.formatLabel = formatLabel;
exports.formatKidsStatus = formatKidsStatus;
exports.formatWantsKids = formatWantsKids;
exports.formatPronouns = formatPronouns;
exports.formatRelationshipIntent = formatRelationshipIntent;
exports.formatEthnicities = formatEthnicities;
exports.formatPetsList = formatPetsList;
const labels_1 = require("./labels");
// Generic label formatter (fallback for unknown values)
function formatLabel(value) {
    return value
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (c) => c.toUpperCase());
}
// Helper to create a formatter function from a label map
function createFormatter(labels) {
    return (value) => labels[value] || formatLabel(value);
}
// Single-value formatters
exports.formatFrequency = createFormatter(labels_1.FREQUENCY_LABELS);
exports.formatExercise = createFormatter(labels_1.EXERCISE_LEVEL_LABELS);
exports.formatZodiacSign = createFormatter(labels_1.ZODIAC_SIGN_LABELS);
exports.formatBodyType = createFormatter(labels_1.BODY_TYPE_LABELS);
exports.formatEducation = createFormatter(labels_1.EDUCATION_LEVEL_LABELS);
exports.formatEmployment = createFormatter(labels_1.EMPLOYMENT_STATUS_LABELS);
exports.formatIncome = createFormatter(labels_1.INCOME_RANGE_LABELS);
exports.formatFlexibility = createFormatter(labels_1.FLEXIBILITY_LABELS);
exports.formatRelationshipStructure = createFormatter(labels_1.RELATIONSHIP_STRUCTURE_LABELS);
exports.formatLanguage = createFormatter(labels_1.LANGUAGE_LABELS);
exports.formatEthnicity = createFormatter(labels_1.ETHNICITY_LABELS);
exports.formatPoliticalView = createFormatter(labels_1.POLITICAL_VIEW_LABELS);
exports.formatReligion = createFormatter(labels_1.RELIGION_LABELS);
exports.formatSexualOrientation = createFormatter(labels_1.SEXUAL_ORIENTATION_LABELS);
exports.formatCareerField = createFormatter(labels_1.CAREER_FIELD_LABELS);
// Special formatters that need custom logic
function formatKidsStatus(value) {
    const map = {
        no: "Doesn't have kids",
        yes: 'Has kids',
        pnta: 'Prefer not to answer',
    };
    return map[value] || formatLabel(value);
}
function formatWantsKids(value, hasKids) {
    // If they already have kids, add "more" to all labels
    if (hasKids === 'yes') {
        const mapWithMore = {
            no: "Doesn't want more kids",
            someday: 'Wants more kids someday',
            soon: 'Wants more kids soon',
            not_sure: 'Not sure about more kids',
            pnta: 'Prefer not to answer',
        };
        return mapWithMore[value] || formatLabel(value);
    }
    const map = {
        no: "Doesn't want kids",
        someday: 'Wants kids someday',
        soon: 'Wants kids soon',
        not_sure: 'Not sure about kids',
        pnta: 'Prefer not to answer',
    };
    return map[value] || formatLabel(value);
}
function formatPronouns(pronouns, custom) {
    if (!pronouns || pronouns.length === 0)
        return '';
    return pronouns.map(p => {
        if (p === 'custom')
            return custom || 'Custom';
        return labels_1.PRONOUNS_LABELS[p] || formatLabel(p);
    }).join(', ');
}
function formatRelationshipIntent(intents) {
    if (!intents || intents.length === 0)
        return '';
    return intents.map(i => labels_1.RELATIONSHIP_INTENT_LABELS[i] || formatLabel(i)).join(', ');
}
function formatEthnicities(ethnicities) {
    if (!ethnicities || ethnicities.length === 0)
        return '';
    return ethnicities.map(exports.formatEthnicity).join(', ');
}
function formatPetsList(pets) {
    if (!pets)
        return '';
    if (pets === 'none')
        return 'None';
    if (Array.isArray(pets)) {
        return pets.map(p => labels_1.PET_TYPE_LABELS[p] || formatLabel(p)).join(', ');
    }
    return labels_1.PET_TYPE_LABELS[pets] || formatLabel(pets);
}
